module.exports = __webpack_public_path__ + "static/assets/1698f4ae730c872272d1d088b34ae785.svg";